import { FC } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Button from '../shared/Buttton'

interface MessageModalProps {
  errorMessage: string
  onOk: () => void
}

const MessageModal: FC<MessageModalProps> = (props) => {
  const { onOk, errorMessage } = props
  const intl = useIntl()
  return (
    <Container>
      <MessageWrapper>{errorMessage}</MessageWrapper>
      <GreyButton onClick={() => onOk()}>{intl.formatMessage({ id: 'MessageModal.OK' })}</GreyButton>
    </Container>
  )
}

const Container = styled.div`
  max-width: 100%;
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const MessageWrapper = styled.p`
  font-size: ${({ theme }) => theme.size.normal};
  margin-bottom: 20px;
`

const GreyButton = styled(Button)`
  width: 140px;
  color: ${({ theme }) => theme.color.black};
  font-size: ${({ theme }) => theme.size.smaller};
  background-color: ${({ theme }) => theme.color.lightGrey};
`

export default MessageModal
